import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import DocumentUploadItem from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/DocumentsTabContent/DocumentUploadItem'
import { GetCreditApplicationDetails_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument } from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/GetCreditApplicationDetails.gql'

import styles from './styles.module.scss'

type CreditApplicationDocument =
  GetCreditApplicationDetails_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument

export interface OtherDocumentsSectionProps {
  salesforceCreditId: string
  documents: CreditApplicationDocument[]
  hasRequiredDocuments: boolean
}

const OtherDocumentsSection = ({ salesforceCreditId, documents, hasRequiredDocuments }: OtherDocumentsSectionProps) => {
  const [getClassName] = useNameFormatter('OtherDocumentsSection')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('title')]}>
        {hasRequiredDocuments ? (
          <FormattedMessage
            defaultMessage='Other documents'
            id='sputnik.OtherDocumentsSection__W1JzjR'
          />
        ) : (
          <FormattedMessage
            defaultMessage='Documents'
            id='sputnik.OtherDocumentsSection__vBlT6y'
          />
        )}
      </div>
      {documents.map((doc) => (
        <DocumentUploadItem
          key={doc.documentUuid}
          document={doc}
          salesforceCreditId={salesforceCreditId}
        />
      ))}
    </div>
  )
}

export default OtherDocumentsSection
